import type { SilaeAddonSchema } from '@libs/data-access/entities'
import { type QueryFnParams, httpServices } from '@libs/data-access/queries'

export type FetchSilaeAddonOptions = QueryFnParams<{}>

export const fetchSilaeAddon = async (opts?: FetchSilaeAddonOptions) => {
  const response = await httpServices.core.get<SilaeAddonSchema>(
    '/silae/addon_pricings',
    opts
  )
  return response.data
}
